import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.overview.widget.wordcloud');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import WordCloud from 'wordcloud';

@Component({
    selector: 'wiz-portal-overview-widget-wordcloud',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.overview.widget.wordcloud/view.scss */
/* src/app/portal.overview.widget.wordcloud/view.scss: no such file or directory */`],
})
export class PortalOverviewWidgetWordcloudComponent implements OnInit {
    @Input() data!: ResearcherData;
    @Input() period: any;

    public researcher: any[];
    public products: any[];
    public periodStart: number;
    public periodEnd: number;

    private isDrawing = false;
    private drawQueued = false;
    private lastW = 0;
    private lastH = 0;

    private hostEl?: HTMLElement;
    private canvasEl?: HTMLCanvasElement;
    private targetW = 0;
    private targetH = 0;

    private guardRetries = 0;          // 재시도 회수(최대 2)
    private bottomBoostPx = 0;         // 추가 하단 패딩(px, device px)
    private fontCapShrink = 0;         // 최대 글자 캡 감소 비율(0.00 ~ 0.08)

    private forceRedraw = false;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            const curr = changes['period'].currentValue;
            this.periodStart = curr?.start;
            this.periodEnd = curr?.end;
            this.forceRedraw = true;
            this.requestDraw();
        }
    }

    constructor(@Inject( Service)         public service: Service,    ) { }

    private wcResizeObs?: ResizeObserver;
    private noKeywords = false; // 키워드 없음 표시용 flag

    private normalizeKeyword(kw: string): string {
        // 공백 제거 + 소문자 변환
        return kw.replace(/\s+/g, '').toLowerCase();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.mapping();
        await this.service.render();
    }

    private requestDraw() {
        if (this.drawQueued) return;
        this.drawQueued = true;
        requestAnimationFrame(() => {
            this.drawQueued = false;
            this.drawWordCloudOnce();
        });
    }

    ngAfterViewInit() {
        this.hostEl = document.getElementById('wc-host') as HTMLElement | null || undefined;
        this.canvasEl = document.getElementById('wc') as HTMLCanvasElement | null || undefined;
        if (!this.hostEl || !this.canvasEl) return;

        // 최초 1회
        const cr = this.hostEl.getBoundingClientRect();
        this.targetW = Math.max(2, Math.round(cr.width));
        this.targetH = Math.max(2, Math.round(cr.height));

        // ✅ 탭 복귀/초기 진입 시 강제 redraw
        this.forceRedraw = true;
        this.requestDraw();

        // ✅ 1프레임 뒤에 한 번 더 (레이아웃 늦게 잡히는 경우 커버)
        requestAnimationFrame(() => {
            this.forceRedraw = true;
            this.requestDraw();
        });

        // host 크기 변화 감지 (contentRect 사용)
        this.wcResizeObs?.disconnect();
        this.wcResizeObs = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (!entry) return;
            const r = entry.contentRect;

            const w = Math.max(2, Math.round(r.width));
            const h = Math.max(2, Math.round(r.height));

            // 변화 없으면 패스
            if (Math.abs(w - this.targetW) <= 1 && Math.abs(h - this.targetH) <= 1) return;

            this.targetW = w;
            this.targetH = h;
            this.requestDraw();
        });

        this.wcResizeObs.observe(this.hostEl as Element);
    }


    ngOnDestroy() {
        this.wcResizeObs?.disconnect();
    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.periodEnd = this.period.end;
        this.periodStart = this.period.start;
        this.products = this.data.products;
        this.service.render();
    }

    private extractKeywords(): Array<{ text: string; weight: number }> {
        const allKeywords: string[] = [];

        for (const p of this.products ?? []) {
            const year = Number(p.pub_year);
            if (year < this.periodStart || year > this.periodEnd) continue;

            let raw = p.kr_keywords?.trim();
            if (!raw) raw = p.en_keywords?.trim();

            if (raw) {
                const parts = raw.split(';')
                    .map(x => x.trim())
                    .filter(x => x.length > 0);
                allKeywords.push(...parts);
            }
        }

        if (allKeywords.length === 0) {
            this.noKeywords = true;
            return [];
        }

        this.noKeywords = false;

        // 키워드별 등장 횟수 카운트 (정규화 적용)
        const freq: Record<string, number> = {};
        const displayMap: Record<string, string> = {}; // 원래 형태 보존용

        for (const kw of allKeywords) {
            const norm = this.normalizeKeyword(kw);
            freq[norm] = (freq[norm] || 0) + 1;
            // 제일 처음 들어온 형태를 표시용으로 저장
            if (!displayMap[norm]) displayMap[norm] = kw;
        }

        const MAX_TOKEN_LEN = 40;

        return Object.entries(freq).map(([norm, weight]) => {
            let shown = displayMap[norm];
            if (shown.length > MAX_TOKEN_LEN) shown = shown.slice(0, MAX_TOKEN_LEN) + '…';
            return { text: shown, weight };
        }).filter(x => x.text.trim().length > 0);
    }

    private drawWordCloudOnce() {
        if (this.isDrawing) return;
        const canvas = this.canvasEl;
        const host = this.hostEl;
        if (!canvas || !host) return;

        // 1) observer가 준 스냅샷 사용 (재측정 X)
        const w = this.targetW || Math.max(2, Math.round(host.clientWidth));
        const h = this.targetH || Math.max(2, Math.round(host.clientHeight));

        // 의미있는 변화가 없으면 스킵
        if (!this.forceRedraw && Math.abs(w - this.lastW) <= 1 && Math.abs(h - this.lastH) <= 1) return;

        // 2) 사이즈 먼저 고정 & 기록
        this.lastW = w;
        this.lastH = h;

        const dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
        const pxW0 = Math.ceil(w * dpr);
        const pxH0 = Math.ceil(h * dpr);
        const fudgePx = Math.max(2, Math.ceil(6 * dpr));
        const pxW = pxW0;
        const pxH = pxH0 + fudgePx;
        const cssW = `${w}px`, cssH = `${h}px`;
        if (canvas.style.width !== cssW) canvas.style.width = cssW;
        if (canvas.style.height !== cssH) canvas.style.height = cssH;

        if (canvas.width !== pxW) canvas.width = pxW;
        if (canvas.height !== pxH) canvas.height = pxH;

        // 3) 키워드 한 번만 뽑기
        const data = this.extractKeywords();

        // noKeywords 처리
        if (this.noKeywords) {
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.font = `${16 * dpr}px Pretendard, sans-serif`;
                ctx.fillStyle = '#888';
                ctx.textAlign = 'center';
                ctx.fillText('키워드가 없습니다.', canvas.width / 2, canvas.height / 2);
            }
            return;
        }

        this.isDrawing = true;

        (document.fonts?.ready ?? Promise.resolve()).then(() => {
            const MAX_WORDS = 150;
            const list = data
                .slice(0, MAX_WORDS)
                .map(d => [d.text, d.weight] as [string, number])
                .sort((a, b) => b[1] - a[1]);   // ✅ 가장 큰 단어가 0번 인덱스

            const padCssBase = Math.max(12, Math.round(Math.min(w, h) * 0.04));
            const padTopCss = padCssBase, padLeftCss = padCssBase, padRightCss = padCssBase;

            const basis = Math.min(w - 2 * padCssBase, h - 2 * padCssBase);
            const cssMin = Math.max(12, Math.floor(basis * 0.03));
            const cssMaxPre = Math.min(64, Math.max(cssMin + 6, Math.floor(basis * 0.12)));

            const extraBottomCss = Math.ceil(cssMaxPre * 0.50); // 기존보다 살짝 여유
            const padBottomCss = padCssBase + extraBottomCss + Math.ceil((this.bottomBoostPx || 0) / dpr);

            // DPR 변환
            const padT = Math.floor(padTopCss * dpr);
            const bottomPixelGuard = 10; // device px 기준 1줄
            // padB에 1px만 추가
            const padB = Math.floor(padBottomCss * dpr) + bottomPixelGuard;
            const padL = Math.floor(padLeftCss * dpr);
            const padR = Math.floor(padRightCss * dpr);

            // 안쪽 영역
            const innerPxW = Math.max(2, pxW - padL - padR);
            const innerPxH = Math.max(2, pxH - padT - padB);
            const innerCssW = Math.max(2, w - padLeftCss - padRightCss);

            const innerCssH = Math.max(2, h - padTopCss - padBottomCss - bottomPixelGuard / dpr);

            const maxW = Math.max(...data.map(d => d.weight), 1);
            const topCapRatio = 0.29;
            const cssMax = Math.min(
                64,
                Math.max(cssMin + 6, Math.floor(Math.min(innerCssW, innerCssH) * 0.12)),
                Math.floor((Math.min(innerPxW, innerPxH) * topCapRatio) / dpr)
            );

            const weightFactor = (wgt: number) => {
                const t = wgt / maxW;
                const sizeCssPx = Math.round(cssMin + (cssMax - cssMin) * Math.pow(t, 0.9));
                return sizeCssPx * dpr;
            };

            const palette = ['#2B438D', '#3361DE', '#FF8CCF', '#4FD1B8', '#5A43D1'];
            const hexToRgb = (hex: string) => {
                const h2 = hex.replace('#', '');
                const n = parseInt(h2.length === 3 ? h2.split('').map(c => c + c).join('') : h2, 16);
                return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
            };
            const color = (_: string, weight: number) => {
                const base = palette[(Math.random() * palette.length) | 0];
                const { r, g, b } = hexToRgb(base);
                const t = weight / maxW;
                const alpha = 0.3 + 0.7 * t;
                return `rgba(${r},${g},${b},${alpha})`;
            };
            
            try {
                (WordCloud as any).stop?.(canvas);
                (WordCloud as any)(canvas, {
                    list,
                    gridSize: Math.max(8, Math.floor((innerCssW + innerCssH) / 80) * 1.2) * dpr,
                    weightFactor,
                    randomPlacement: false,
                    spiral: 'archimedean',
                    rotateRatio: 0.0,
                    rotationSteps: 0,
                    minRotation: 0,
                    maxRotation: 0,
                    ellipticity: 0.9,
                    drawOutOfBound: false,
                    shrinkToFit: false,
                    clearCanvas: true,
                    backgroundColor: 'rgba(0,0,0,0)',
                    color,
                    fontFamily: 'Pretendard, Noto Sans KR, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
                    shuffle: false,
                    origin: [padL + innerPxW / 2, padT + innerPxH / 2],
                });
            } finally {
                requestAnimationFrame(() => {
                    // 하단 3px 스트립에 픽셀이 있나 검사
                    const ctx = canvas.getContext('2d');
                    if (!ctx) { this.isDrawing = false; return; }

                    const stripH = Math.max(2, Math.ceil(3 * dpr));
                    const img = ctx.getImageData(0, canvas.height - stripH, canvas.width, stripH).data;

                    let touched = false;
                    for (let i = 3; i < img.length; i += 4) { // 알파 채널만 검사
                        if (img[i] !== 0) { touched = true; break; }
                    }

                    if (touched && this.guardRetries < 2) {
                        // 하단 여유 + 폰트 캡 살짝 감소
                        const bump = Math.ceil(cssMaxPre * 0.45 * dpr); // 20%만 추가
                        this.bottomBoostPx = (this.bottomBoostPx || 0) + bump;
                        this.fontCapShrink = Math.min((this.fontCapShrink || 0) + 0.02, 0.08); // 캡 2% 줄임
                        this.guardRetries += 1;

                        this.isDrawing = false; // 재그리기 허용
                        this.requestDraw();     // 다시 그리기
                        return;
                    }

                    // 성공 or 재시도 소진 → 상태 리셋
                    this.guardRetries = 0;
                    this.isDrawing = false;
                });
            }
        });

        this.forceRedraw = false;
    }
}

export default PortalOverviewWidgetWordcloudComponent;